import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React, { useState } from "react";
import {
  FaArrowDown,
  FaArrowLeft,
  FaCartPlus,
  FaCircle,
  FaDiceThree,
  FaFileCode,
  FaSquare,
  FaThermometerEmpty,
  FaUser,
  FaWallet,
} from "react-icons/fa";
import { useRouteInfo } from "../hooks/useRouteInfo";
import { Helmet } from "react-helmet";

const questions = [
  {
    icon: <FaUser />,
    name: "ثبت نام در ۱۹۲۴ ",
    questions: [
      {
        question: "چگونه ماشین سنگین خود را در سایت 1924 آگهی کنم؟",
        answer: `<div style="text-align: right; "><span style="font-family: verdana; font-size: 16px;"></span></div>
چگونه ماشین سنگین خود را در سایت 1924 آگهی کنم؟
<div>
<p>برای آگهی کردن ماشین سنگین خود در سایت 1924، شما دو روش پیش رو دارید:<br />
</p>
<p>1. ثبت آگهی از طریق فرم آنلاین سایت:<br />
</p>
<p>به سایت 1924.ir مراجعه کنید و به بخش ثبت درخواست در ابتدا صفحه اصلی بروید.<br />
</p>
<p>اطلاعات را با دقت پر کنید. اطلاعاتی مانند:<br />
</p>
<p>خریدار یا فروشنده بودن، نوع ماشین (کامیون، کامیونت، کشنده، و غیره)، مدل و سال ساخت، وضعیت فنی و شخصی یا تجاری بودن ماشین، توضیحات تکمیلی (مثل کارکرد، رنگ، بیمه، و هر ویژگی خاص)، قیمت و تلفن تماس<br />
</p>
<p>پس از پر کردن فرم مشاوران برای کسب اطلاعات دقیق تر با شما تماس میگیرند.<br />
</p>
<p>2. تماس با کارشناسان 1924:<br />
</p>
<p>اگر تمایل دارید تا آگهی خود را سریع‌تر و با کمک کارشناسان ثبت کنید، می‌توانید با پشتیبانی یا کارشناسان سایت تماس بگیرید. آنها به شما در تکمیل مراحل ثبت آگهی کمک خواهند کرد و از طریق تماس تلفنی یا آنلاین، می‌توانید جزئیات بیشتری را در اختیار آنها قرار دهید. با یکی از این روش‌ها می‌توانید ماشین سنگین خود را در سایت 1924 آگهی کرده و سریع‌تر به فروش برسانید.<br />
</p>
<p><br />
</p>
</div>`,
      },
      {
        question: "آیا برای استفاده از سایت 1924 نیاز به پرداخت اشتراک است؟",
        answer:
          "خیر، استفاده از سایت 1924 برای خریداران و فروشندگان رایگان است.",
      },
      {
        question: "هزینه ثبت آگهی در 1924 چقدر است؟",
        answer: "ثبت آگهی در 1924 به صورت رایگان انجام می‌شود.",
      },
    ],
  },
  {
    icon: <FaCartPlus />,
    name: "شرایط اقساطی",
    questions: [
      {
        question: "آیا امکان خرید اقساطی ماشین سنگین در سایت 1924 وجود دارد؟",
        answer:
          "بله، در سایت 1924 امکان خرید اقساطی انواع ماشین‌های سنگین وجود دارد. تمام افراد می‌توانند برای خرید کامیون، کامیونت، کشنده و سایر وسایل نقلیه سنگین از شرایط اقساطی استفاده کنند. این روش به خریداران کمک می‌کند تا بدون پرداخت کامل مبلغ به صورت یکجا، وسیله نقلیه مورد نظر خود را تهیه کرده و اقساط آن را به صورت دوره‌ای پرداخت کنند. برای اطلاعات بیشتر درباره شرایط خرید اقساطی، می‌توانید با پشتیبانی تماس بگیرید.",
      },
      {
        question: "شرایط اقساط در ۱۹۲۴ به چه صورت است؟",
        answer:
          "برای خرید اقساطی از ۱۹۲۴ تنها داشتن چک صیادی کفایت می کند. برای کسب اطلاعات بیشتر میتوانید با کارشناسان ما در ارتباط باشید .",
      },
    ],
  },
  {
    icon: <FaDiceThree />,
    name: "سایر",
    questions: [
      {
        question: "آیا امکان مقایسه ماشین‌ها در سایت 1924 وجود دارد؟",
        answer:
          "بله، با استفاده از صفحه مقایسه در سایت، می‌توانید مشخصات فنی، قیمت و ویژگی‌های چند ماشین را کنار هم مشاهده کرده و بهترین انتخاب را داشته باشید.",
      },
      {
        question: "آیا 1924 اپلیکیشن موبایل دارد؟",
        answer:
          "بله، سایت 1924 دارای اپلیکیشن موبایل برای اندروید و IOS است. این اپلیکیشن به کاربران این امکان را می‌دهد که به راحتی و از طریق گوشی‌های هوشمند خود، به جستجو، خرید و فروش ماشین‌های سنگین بپردازند.",
      },

      {
        question: "چه نوع ماشین‌های سنگینی در سایت 1924 خرید و فروش می‌شوند؟",
        answer:
          "در سایت 1924، انواع ماشین‌های سنگین مانند کامیون، تریلر، کشنده، کامیونت و ماشین‌آلات سنگین دیگر مانند لودر و بیل مکانیکی خرید و فروش می‌شود.",
      },
      {
        question: "مزیت استفاده از 1924 برای خرید و فروش ماشین سنگین چیست؟",
        answer:
          "سایت 1924 یک پلتفرم تخصصی و کاربرپسند است که با ارائه ابزارهای پیشرفته جستجو، مقایسه، و کارشناسی، فرآیند خرید و فروش را ساده و سریع می‌کند.",
      },
    ],
  },
];

const FAQPage = () => {
  const [selected, setSelected] = useState("ثبت نام در ۱۹۲۴ ");
  const { metaData } = useRouteInfo();
  return (
    <div className=" mb-20 ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>
      <div className="relative  z-10 pt-24 pb-8 lg:pt-10 flex-col items-center justify-center flex">
        <h1 className="text-center font-bold justify-center flex gap-2 items-center  text-[24px] lg:text-[36px] ">
          <FaSquare size={12} color="#F37324" />
          سوالات متداول
        </h1>
      </div>
      <div className="bg-white px-3 xl:px-16 lg:py-10 2xl:px-20 grid lg:grid-cols-3 gap-5">
        <span className="bg-[#F5F8FC] rounded-[20px] px-2 py-8 hidden lg:block">
          <span className="flex flex-col items-center justify-center">
            <img src="/logo_1924.svg" alt="لوگوی 1924" className="w-[230px]" />
            <span className="text-[10px] font-medium">
              مرکز خرید و فروش ماشین های سنگین
            </span>
          </span>
          <div className="pt-8">
            <h3 className="text-[#205398] text-[20px] p-4">
              دسته بندی پرسش ها
            </h3>
            <div className=" text-[#336CA4] lg:text-[16px] px-2">
              {questions.map((item) => (
                <button
                  onClick={() => setSelected(item.name)}
                  className="py-4 w-full items-center flex border-b border-[#E4EAF0] justify-between"
                >
                  <span className="flex items-center gap-2">{item.name}</span>
                  <FaArrowLeft className="me-4" />
                </button>
              ))}
            </div>
          </div>
        </span>
        <span className="lg:col-span-2">
          <div className="lg:hidden grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5 px-7 mb-10">
            <span className="col-span-full text-[#000] text-[20px] text-center">
              دسته بندی پرسش ها
            </span>
            {questions?.map((item) => {
              if (item.name === selected) {
                return (
                  <button
                    onClick={() => setSelected(item.name)}
                    className="border border-[#E4EAF0] bg-[#000] rounded-[15px] flex flex-col items-center justify-center p-6 text-[#fff] text-[14px] gap-3"
                  >
                    {item.name}
                  </button>
                );
              }
              return (
                <button
                  onClick={() => setSelected(item.name)}
                  className="border border-[#E4EAF0] bg-[#F5F8FC] rounded-[15px] flex flex-col items-center justify-center p-6 text-[#336CA4] text-[14px] gap-3"
                >
                  {item.name}
                </button>
              );
            })}
          </div>
          <div className="lg:hidden">
            {questions
              .find((e) => selected == e.name)
              .questions.map((q, index) => (
                <Accordion
                  sx={{
                    boxShadow: "none",
                    border: "none",
                    outline: "none",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<FaArrowDown />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      boxShadow: "none",
                      border: "none",
                      outline: "none",
                    }}
                    className="text-[12px] font-[600]"
                  >
                    <span className="text-[#F37324] font-[Dana-farsi-bold] me-2">
                      {index + 1}
                    </span>{" "}
                    {q.question}
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      boxShadow: "none",
                      border: "none",
                      outline: "none",
                    }}
                    className="text-[10px] text-[#7E8AAB]"
                  >
                    <div dangerouslySetInnerHTML={{ __html: q.answer }} />
                  </AccordionDetails>
                </Accordion>
              ))}
          </div>

          <div className="border-[#E4EAF0] border rounded-[16px] hidden lg:block p-5">
            <h3 className=" lg:text-[24px] mb-5 font-bold">
              {questions.find((e) => selected == e.name).name}
            </h3>
            {questions
              .find((e) => selected == e.name)
              .questions.map((q) => (
                <div className="mt-8">
                  <h5 className=" flex items-center gap-2 font-bold">
                    <FaCircle size={12} color="#F37324" />
                    {q.question}
                  </h5>
                  <div
                    className="text-[#626E94] mt-3"
                    dangerouslySetInnerHTML={{ __html: q.answer }}
                  />
                </div>
              ))}
          </div>
        </span>
      </div>
    </div>
  );
};

export default FAQPage;
